/**
 * I punti mappa (`MapPointsResourceImpl`) nei mock: elenco del sito, creazione, spostamento e
 * cancellazione. Il seed è vuoto: i punti li crea chi usa i mock (l'agenda di F2 per i task, FILO-41).
 */
import { http, HttpResponse } from 'msw';
import type { MapPoint } from '../../entities/mapPoint/mapPointTypes';

const API = '/o/crm/v1_0';

export const mockMapPoints: MapPoint[] = [];

const nextId = () => mockMapPoints.reduce((max, p) => Math.max(max, p.mapPointId), 0) + 1;

// COORDINATES: le coordinate di un'azienda stanno sui suoi indirizzi (FILO-52). Come
// MapPointLocalServiceImpl.validate, conta il proprietario dopo la scrittura.
const BUSINESS_CLASS = 'it.dvel.crm.core.model.Business';
const businessPointRejected = () =>
  HttpResponse.json(
    { status: 'BAD_REQUEST', title: "Il punto mappa di un'azienda sta sul suo indirizzo, non sull'azienda." },
    { status: 400 },
  );

export const mapPointHandlers = [
  http.get(`${API}/map-points/:groupId`, ({ params, request }) => {
    const url = new URL(request.url);
    const className = url.searchParams.get('className');
    const classPK = Number(url.searchParams.get('classPK') ?? 0);
    const items = mockMapPoints.filter((p) => p.groupId === Number(params.groupId) &&
      (!className || p.className === className) && (!classPK || p.classPK === classPK));
    return HttpResponse.json({ items, page: 1, pageSize: items.length, totalCount: items.length, lastPage: 1 });
  }),

  http.post(`${API}/map-points/:groupId`, async ({ params, request }) => {
    const body = (await request.json()) as Omit<MapPoint, 'mapPointId' | 'groupId'>;
    if (body.className === BUSINESS_CLASS) return businessPointRejected();
    const created: MapPoint = { ...body, mapPointId: nextId(), groupId: Number(params.groupId) };
    mockMapPoints.push(created);
    return HttpResponse.json(created);
  }),

  http.patch(`${API}/map-point/:id`, async ({ params, request }) => {
    const point = mockMapPoints.find((p) => p.mapPointId === Number(params.id));
    if (!point) return new HttpResponse(null, { status: 404 });
    const patch = (await request.json()) as Partial<MapPoint>;
    if ((patch.className ?? point.className) === BUSINESS_CLASS) return businessPointRejected();
    Object.assign(point, patch, { mapPointId: point.mapPointId });
    return HttpResponse.json(point);
  }),

  http.delete(`${API}/map-point/:id`, ({ params }) => {
    const i = mockMapPoints.findIndex((p) => p.mapPointId === Number(params.id));
    if (i < 0) return new HttpResponse(null, { status: 404 });
    mockMapPoints.splice(i, 1);
    return new HttpResponse(null, { status: 204 });
  }),
];
